

export default {

    computed: {
        options () {
            return {
                shortcuts: [
                    {
                        text: this.$t("global.common.latest_week", {
                            defaultValue: "最近一周",
                        }),
                        value () {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(
                                start.getTime() - 3600 * 1000 * 24 * 7
                            );
                            return [start, end];
                        },
                    },
                {
                    text: this.$t("global.common.recent_month", {
                        defaultValue: "最近一月",
                    }),
                    value () {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(
                            start.getTime() - 3600 * 1000 * 24 * 30
                        );
                        return [start, end];
                    },
                },
                {
                    text: this.$t("global.common.latest_quarter", {
                        defaultValue: "最近一季度",
                    }),
                    value () {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(
                            start.getTime() - 3600 * 1000 * 24 * 90
                        );
                        return [start, end];
                    },
                },
              ],
            };
        },
        // 商品状态
        getBillStatus() {
            return [{
                label: this.$tc('fbb.setting.goods_status', 0, { defaultValue: '草稿' }),
                value: '0',
            }, {
                label: this.$tc('fbb.setting.goods_status', 1, { defaultValue: '已确认' }),
                value: '70',
                theme:'success'
            }, {
                label: this.$tc('fbb.setting.goods_status', 2, { defaultValue: '已取消' }),
                value: '90',
            }]
        },
        //  库存类型
        getInventoryType() {
            return [{
                label: "可售库存",
                value: 0,
            }, {
                label: "不可售库存",
                value: 1,
            }]
        },
        // 处理状态
        getOrderStatus() {
            return [
            {
                label: this.$tc('fbb.sales.sales_status', 0, { defaultValue: '全部' }),
                value: null,
            },
            {
                label: this.$tc('fbb.sales.sales_status', 1, { defaultValue: '待认领' }),
                value: 0,
                theme:'error'
            },
            {
                label: this.$tc('fbb.sales.sales_status', 2, { defaultValue: '待处理' }),
                value: 5,
                theme: 'primary'
            },
            {
                label: this.$tc('fbb.sales.sales_status', 2, { defaultValue: '处理中' }),
                value: 10,
                theme: 'primary'
            },
            {
                label: this.$tc('fbb.sales.sales_status', 2, { defaultValue: '处理完成' }),
                value: 15,
                theme: 'success'
            },
            {
                label: this.$tc('fbb.sales.sales_status', 2, { defaultValue: '待销毁' }),
                value: 20,
                theme: 'gray'
            },
            {
                label: this.$tc('fbb.sales.sales_status', 2, { defaultValue: '已销毁' }),
                value: 25,
                theme: 'dark'
            }]
        },
        // 来源类型
        getSourceSystem(){
            return [
                {
                    label: this.$t('', { defaultValue : '销售退货' }),
                    value: 1
                },
                {
                    label: this.$t('', { defaultValue : '销售退货' }),
                    value: 8
                },
                {
                    label: this.$t('', { defaultValue : '无来源入库' }),
                    value: 0
                },]
        },
        // 异常类型
        getErrorSimpleType(){
            return [
                {
                    label: "推送异常",
                    value: '0'
                },
                {
                    label: "回传异常",
                    value: '1'
                },
                {
                    label: "取消异常",
                    value: '2'
                },
                {
                    label: "测算异常",
                    value: '3'
                },
                {
                    label: "Label购买异常",
                    value: '4'
                },
                {
                    label: "审核异常",
                    value: '5'
                },
                {
                    label: "单据完成异常",
                    value: '6'
                },
                {
                    label: "单据发运异常",
                    value: '7'
                },
                {
                    label: "wms单据创建异常",
                    value: '8'
                },
                {
                    label: "wms单据完成异常",
                    value: '9'
                },
                {
                    label: "确认异常",
                    value: '10'
                },
                {
                    label: "附件推送异常",
                    value: '11'
                },
                {
                    label: "清理在途",
                    value: '12'
                },
                {
                    label: "销毁异常",
                    value: '13'
                },]
        },
        getErrorSimpleType1(){
            return [
                {
                    label: "推送异常",
                    value: '0'
                },
                {
                    label: "回传异常",
                    value: '1'
                },
                {
                    label: "取消异常",
                    value: '2'
                },
                {
                    label: "单据完成异常",
                    value: '6'
                },
                {
                    label: "附件推送异常",
                    value: '11'
                },]
        },
        // 处理方式
        getHandleType(){
            return [
                {
                    label: "未定义",
                    value: -1
                },
                {
                    label: "卖家自提",
                    value: 0
                },
                {
                    label: "拍照确认",
                    value: 1
                },
                {
                    label: "销毁",
                    value: 2
                },
                {
                    label: "上架(良品)",
                    value: 3
                },
                {
                    label: "换标上架(良品)",
                    value: 4
                },
            ]
        },
        // 产品类型
        getGoodsType() {
            return [{
                label: this.$tc('fbb.sales.goods_type', 0, { defaultValue: '成品' }),
                value: '0',
            }, {
                label: this.$tc('fbb.sales.goods_type', 1, { defaultValue: '配件' }),
                value: '1',
            }, {
                label: this.$tc('fbb.sales.goods_type', 2, { defaultValue: '耗材' }),
                value: '2',
            }]
        },
        // 处理状态
        getClaimOrderHandleOrderStatus() {
            return [
            {
                label: this.$tc('fbb.sales.sales_status', 0, { defaultValue: '全部' }),
                value: null,
            },
            {
                label: this.$t('', { defaultValue: "草稿" }),
                value: '0',
            },
            {
                label: this.$t('', { defaultValue: "已确认" }),
                value: '5',
            }]
        },
        // 商品收货状态
        getPlanCustomOrderStatus() {
           return [
           {
               label: this.$tc('fbb.sales.sales_status', 0, { defaultValue: '全部' }),
               value: null,
           },
           {
               label: this.$tc('fbb.sales.sales_status', 1, { defaultValue: '待审核' }),
               value: 5,
               theme: 'darkgray',
           },
           {
               label: this.$tc('fbb.sales.sales_status', 2, { defaultValue: '收货中' }),
               value: 10,
               theme: 'primary',
           },
           {
               label: this.$tc('fbb.sales.sales_status', 2, { defaultValue: '审核拒回' }),
               value: 20,
               theme: 'error'
           },
           {
               label: this.$tc('fbb.sales.sales_status', 2, { defaultValue: '待收货' }),
               value: 30,
               theme: 'darkgray',
           },
           {
               label: this.$tc('fbb.sales.sales_status', 2, { defaultValue: '收货完成' }),
               value: 70,
               theme: 'success',
           },
           {
               label: this.$tc('fbb.sales.sales_status', 2, { defaultValue: '已取消' }),
               value: 90,
               theme: 'warning'
           }]
        },
        // 商品确认状态
        getConfirmStatus(){
            return [
                {
                    label: this.$t('', { defaultValue : '无需确认' }),
                    value: 0,
                    theme: 'darkgray',
                },
                {
                    label: this.$t('', { defaultValue : '待确认' }),
                    value: 5,
                    theme: 'warning'
                },
                {
                    label: this.$t('', { defaultValue : '已确认' }),
                    value: 10,
                    theme: 'success'
                },
            ]
        },
        searchSourceSystem(){
            return [
                {
                    label: this.$t('', { defaultValue : '销售退货' }),
                    // value: [1,8]
                    value: 1,
                },
                {
                    label: this.$t('', { defaultValue : '无来源入库' }),
                    value: 0
                }
            ]
        },
        // 处理方式
        getPlanCustomHandleType(){
            return [
                {
                    label: "销毁",
                    value: 2
                },
                {
                    label: "上架(良品)",
                    value: 3
                },
                {
                    label: "换标上架(良品)",
                    value: 4
                },
                {
                    label: "卖家自提",
                    value: 0

                }
            ]
        },
        /**
         * 商品收货状态
         */
        getPlanManageOrderStatus() {
           return [
           {
               label: this.$tc('fbb.sales.sales_status', 0, { defaultValue: '全部' }),
               value: null,
           },
           {
               label: this.$tc('fbb.sales.sales_status', 1, { defaultValue: '待审核' }),
               value: 5,
               theme: 'darkgray',
           },
           {
               label: this.$tc('fbb.sales.sales_status', 2, { defaultValue: '收货中' }),
               value: 10,
               theme: 'primary',
           },
           {
               label: this.$tc('fbb.sales.sales_status', 2, { defaultValue: '审核拒回' }),
               value: 20,
               theme: 'error'
           },
           {
               label: this.$tc('fbb.sales.sales_status', 2, { defaultValue: '待收货' }),
               value: 30,
               theme: 'darkgray',
           },
           {
               label: this.$tc('fbb.sales.sales_status', 2, { defaultValue: '收货完成' }),
               value: 70,
               theme: 'success',
           },
           {
               label: this.$tc('fbb.sales.sales_status', 2, { defaultValue: '已取消' }),
               value: 90,
               theme: 'warning'
           }]
        },
        // 处理状态
        getSalesHandleOrderStatus() {
            return [
            {
                label: this.$tc('fbb.sales.sales_status', 0, { defaultValue: '全部' }),
                value: null,
            },
            {
                label: this.$t('', { defaultValue: "草稿" }),
                value: '0',
                theme: 'darkgray',
            },
            {
                label: this.$t('', { defaultValue: "已取消" }),
                value: '5',
                theme: 'warning'
            },
            {
                label: this.$t('', { defaultValue: '已确认' }),
                value: '10',
                theme: 'success'
            }]
        },
        // 处理状态
        getSalesHandlePlanManageOrderStatus() {
            return [
            {
                label: '待处理',
                value: '0',
                theme: 'primary',
            },
            {
                label: '处理中',
                value: '5',
                theme: 'warning',
            },
            {
                label: '已完成',
                value: '10',
                theme: 'success',
            },]
        },
    }
}
